import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Query, withApollo } from 'react-apollo'
import { Select } from 'antd'
// import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const { Option } = Select

const BARANGAY_HOUSEHOLD = gql`
    query allBarangayHousehold($barangay_uid: String, $searchFilter: SearchParams) {
		allBarangayHousehold(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const Household = (props) => {
	const { 
		client, barangay_uid,
		onSelectedItem, onChange, ...rest 
	} = props
	const [searchText, setSearchText] = useState('')

	return (
		<Query 
			query={BARANGAY_HOUSEHOLD}
			variables={{
				barangay_uid,
				searchFilter: { page: 1, pageSize: 50, searchText }
			}}
			fetchPolicy='network-only'
		>
			{({ loading, error, data }) => {
				const household = _.has(data, 'allBarangayHousehold') ? data.allBarangayHousehold.data : []
				//console.log('purok', purok)
				return (
					<Select { ...rest }
						loading={loading}
						allowClear
						showSearch
						placeholder='Select Household'
						onSearch={(value) => setSearchText(value)}
						notFoundContent={null}
						showArrow={false}
						filterOption={false}
						onChange={(value) => {
							if (onSelectedItem) {
								const mHousehold = _.find(household, (i) => _.isEqual(i.uid, value))
								onSelectedItem(mHousehold)
							}
							onChange(value)
						}}
					>
						{
							household.map((item, key) => (
								<Option key={key} value={item.uid}>{item.household_no}</Option>
							))
						}
					</Select>
				)
			}}
		</Query>
	)
}

const composed = compose(
	withApollo
)

export default composed(Household)